import React from "react";
import { Box, Card, CardContent, Stack, Typography } from "@mui/material";
import CategoryHeader from "../../Components/Headers/CategoryHeader";
import usePaymentPageForCustomer from "./usePaymentPageForCustomer";
import CircularProgressBar from "../../Components/PersonalAccidentComponents/CircularProgressBar/CircularProgressBar";

const PaymentPageForCustomer = () => {
  const { loading, transferData, clickedPayHere, payHere } =
    usePaymentPageForCustomer();

  return (
    <div>
      {loading ? (
        <CircularProgressBar />
      ) : (
        <div>
          {Object.keys(transferData).length > 0 && (
            <CategoryHeader title="Personal Accident Insurance" />
          )}
          <Box sx={{ padding: "16px", marginTop: "16px" }}>
            {Object.keys(transferData).length > 0 && (
              <Card>
                <Box sx={{ display: "flex" }}>
                  <img
                    className="bg-white img-thumbnail rounded"
                    width={100}
                    height={100}
                    src={transferData.logo}
                    alt="company_logo"
                  />
                  <Box>
                    <Typography>{transferData.vendor}</Typography>
                    <Typography>{transferData.product_name}</Typography>
                  </Box>
                </Box>

                <CardContent>
                  <Typography
                    variant="h5"
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      fontWeight: 600,
                    }}
                  >
                    Premium Details
                  </Typography>

                  <div className="mt-3 mb-3">
                    <span style={{ float: "left" }}>Package Premium </span>
                    <span style={{ float: "left", color: "silver" }}>
                      ..................
                    </span>
                    <span style={{ float: "right" }}>
                      <b>{`₹ ${transferData.totalPremium}`}</b>
                    </span>
                    <br />
                    <span style={{ float: "left" }}>GST@18%</span>
                    <span style={{ float: "left", color: "silver" }}>
                      ..................
                    </span>
                    <span style={{ float: "right" }}>
                      <b>{`₹ ${transferData.serviceTax}`}</b>
                    </span>
                    <br />
                    <span style={{ float: "left" }}>Final Premium</span>
                    <span style={{ float: "left", color: "silver" }}>
                      ..................
                    </span>
                    <span style={{ float: "right" }}>
                      <b>{`₹ ${transferData.premium}`}</b>
                    </span>
                  </div>
                </CardContent>
              </Card>
            )}
          </Box>
          <Stack spacing={2} sx={{ padding: "16px", marginTop: "16px" }}>
            {clickedPayHere ? (
              <CircularProgressBar />
            ) : (
              <button className="payment-btn" type="button" onClick={payHere}>
                Pay Here
              </button>
            )}
          </Stack>
        </div>
      )}
    </div>
  );
};

export default PaymentPageForCustomer;
